<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ynM5j6/tc-custom/9780374712891.jpg?1730579307557" alt="This image is the cover for the book Holy Cow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holy Cow
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>X-Files</i> star and bestselling author’s “zany, madcap first novel . . . is a seriously entertaining fable that doesn’t take itself too seriously” (John Wilwol, <i>The Washington Post</i>).</b><br/><br/>Elsie Bovary is a cow, and a pretty happy one at that—her long, lazy days are spent eating, napping, and chatting with her best friend, Mallory. One night, Elsie and Mallory sneak out of their pasture; but while Mallory is interested in flirting with the neighboring bulls, Elsie finds herself drawn to the farmhouse. Through the window, she sees the farmer’s family gathered around a bright Box God—and what the Box God reveals about something called an “industrial meat farm” shakes Elsie’s understanding of her world to its core.<br/><br/>There’s only one solution: escape to a better, safer world. And so a motley crew is formed: Elsie; Jerry—excuse me, Shalom—a cranky, Torah-reading pig who’s recently converted to Judaism; and Tom, a suave (in his own mind, at least) turkey who can’t fly, but who can work an iPhone with his beak. Toting stolen passports and slapdash human disguises, they head for the airport.<br/><br/>Elsie is our wise-cracking, pop-culture-reference-dropping, slyly witty narrator; Tom—who does eventually learn to fly (sort of)—dispenses psychiatric advice in a fake German accent; and Shalom, rejected by his adopted people in Jerusalem, ends up unexpectedly uniting Israelis and Palestinians. David Duchovny’s charismatic creatures point the way toward a mutual understanding and acceptance that the world desperately needs.<br/><br/><b>“Who knew a cow’s view of the world was so funny yet so honest and true? <i>Holy Cow</i> is silly and fun from the opening page.” —Jeff Ayers, <i>The Denver Post</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Duchovny
      </h2>
      
      <p class="authorDescription body article"><P><B>David Duchovny</B> is a television, stage, and screen actor, as well as a screenwriter and director.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0314bd6e